module.exports = __webpack_public_path__ + "media/images/emblems/Unterramsern-blason-26743ac01295b37fdcdc60c66366f1f5.png";